/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import { ValidationErrorFieldsFragmentDoc } from '../../../graphql/fragments/ValidationErrorFields.generated';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type OrderFieldsFragment = {
  readonly __typename?: 'Order';
  readonly id: string;
  readonly orderType: Types.OrderType;
  readonly wantedTime: string;
  readonly description: string;
  readonly total: number | null;
  readonly canCancel: boolean;
  readonly lineItems: ReadonlyArray<{
    readonly __typename?: 'LineItem';
    readonly id: string;
    readonly customName: string | null;
    readonly isCustom: boolean;
    readonly product: {
      readonly __typename?: 'Product';
      readonly id: string;
      readonly name: string;
      readonly isCustom: boolean;
      readonly categoryName: string;
    };
  }>;
  readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
  readonly restaurant: {
    readonly __typename?: 'Restaurant';
    readonly id: string;
    readonly name: string;
    readonly isOutpost: boolean;
  };
  readonly deliveryOrderDetail: {
    readonly __typename?: 'DeliveryOrderDetail';
    readonly id: string;
    readonly address: {
      readonly __typename?: 'Address';
      readonly id: string;
      readonly name: string | null;
    };
  } | null;
};

export type OrderHistoryQueryVariables = Types.Exact<{
  input: Types.OrdersInput;
}>;

export type OrderHistoryQuery = {
  readonly __typename?: 'Query';
  readonly orders:
    | {
        readonly __typename: 'OrdersResponseSuccess';
        readonly pagination: {
          readonly __typename?: 'Pagination';
          readonly total: number;
        };
        readonly orders: ReadonlyArray<{
          readonly __typename?: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly wantedTime: string;
          readonly description: string;
          readonly total: number | null;
          readonly canCancel: boolean;
          readonly lineItems: ReadonlyArray<{
            readonly __typename?: 'LineItem';
            readonly id: string;
            readonly customName: string | null;
            readonly isCustom: boolean;
            readonly product: {
              readonly __typename?: 'Product';
              readonly id: string;
              readonly name: string;
              readonly isCustom: boolean;
              readonly categoryName: string;
            };
          }>;
          readonly asset: {
            readonly __typename?: 'Asset';
            readonly url: string;
          };
          readonly restaurant: {
            readonly __typename?: 'Restaurant';
            readonly id: string;
            readonly name: string;
            readonly isOutpost: boolean;
          };
          readonly deliveryOrderDetail: {
            readonly __typename?: 'DeliveryOrderDetail';
            readonly id: string;
            readonly address: {
              readonly __typename?: 'Address';
              readonly id: string;
              readonly name: string | null;
            };
          } | null;
        }>;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export type OrderHistoryWithIsCanceledFieldQueryVariables = Types.Exact<{
  input: Types.OrdersInput;
}>;

export type OrderHistoryWithIsCanceledFieldQuery = {
  readonly __typename?: 'Query';
  readonly orders:
    | {
        readonly __typename: 'OrdersResponseSuccess';
        readonly pagination: {
          readonly __typename?: 'Pagination';
          readonly total: number;
        };
        readonly orders: ReadonlyArray<{
          readonly __typename?: 'Order';
          readonly isCanceled: boolean;
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly wantedTime: string;
          readonly description: string;
          readonly total: number | null;
          readonly canCancel: boolean;
          readonly lineItems: ReadonlyArray<{
            readonly __typename?: 'LineItem';
            readonly id: string;
            readonly customName: string | null;
            readonly isCustom: boolean;
            readonly product: {
              readonly __typename?: 'Product';
              readonly id: string;
              readonly name: string;
              readonly isCustom: boolean;
              readonly categoryName: string;
            };
          }>;
          readonly asset: {
            readonly __typename?: 'Asset';
            readonly url: string;
          };
          readonly restaurant: {
            readonly __typename?: 'Restaurant';
            readonly id: string;
            readonly name: string;
            readonly isOutpost: boolean;
          };
          readonly deliveryOrderDetail: {
            readonly __typename?: 'DeliveryOrderDetail';
            readonly id: string;
            readonly address: {
              readonly __typename?: 'Address';
              readonly id: string;
              readonly name: string | null;
            };
          } | null;
        }>;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export const orderHistoryQueryMock: ExecutionResult<OrderHistoryQuery> = {
  data: {
    orders: {
      __typename: 'OrdersResponseSuccess',
      pagination: { total: 84 },
      orders: [
        {
          id: '09e6ea9f-ee42-4a99-a258-7ce71904308d',
          orderType: 'DELIVERY',
          wantedTime: 'Hello World',
          description: 'Hello World',
          total: 38,
          canCancel: false,
          lineItems: [
            {
              id: '7163ba7e-da96-4e8a-985e-3da00a9a4753',
              customName: 'Hello World',
              isCustom: false,
              product: {
                id: '319d0806-0b59-4aa2-90f9-c4016b1bd634',
                name: 'Hello World',
                isCustom: true,
                categoryName: 'Hello World',
              },
            },
            {
              id: 'b273b7f9-f18d-4030-b1b1-f2c49f5fd799',
              customName: 'Hello World',
              isCustom: false,
              product: {
                id: 'ccdcab38-b748-45af-be88-532ede7a1daa',
                name: 'Hello World',
                isCustom: true,
                categoryName: 'Hello World',
              },
            },
          ],
          asset: { url: 'Hello World' },
          restaurant: {
            id: '33e0e095-a7b4-48f0-bb56-0d0180d39ca0',
            name: 'Hello World',
            isOutpost: true,
          },
          deliveryOrderDetail: {
            id: '0520a352-a4a6-4541-b5bc-5d089f52e921',
            address: {
              id: 'd91bfdfb-abd3-48fd-b8eb-150587b384c4',
              name: 'Hello World',
            },
          },
        },
        {
          id: '8299be51-1f9b-41e3-9b6d-74afbe52f8a3',
          orderType: 'DELIVERY',
          wantedTime: 'Hello World',
          description: 'Hello World',
          total: 26,
          canCancel: false,
          lineItems: [
            {
              id: '32f0edae-f122-4810-af29-1521b27f2bad',
              customName: 'Hello World',
              isCustom: true,
              product: {
                id: '9c8f96f0-10ca-4153-9642-9788b394138d',
                name: 'Hello World',
                isCustom: false,
                categoryName: 'Hello World',
              },
            },
            {
              id: '004934e0-80ad-47fd-a251-4dd94f36b41c',
              customName: 'Hello World',
              isCustom: false,
              product: {
                id: '3d4c4b96-caa8-4622-a517-d3cbc3f05167',
                name: 'Hello World',
                isCustom: true,
                categoryName: 'Hello World',
              },
            },
            {
              id: '358d451b-9313-4663-9b9e-b2f517f534a2',
              customName: 'Hello World',
              isCustom: false,
              product: {
                id: 'f5acfbda-03bf-4af7-a27a-59a381e64855',
                name: 'Hello World',
                isCustom: true,
                categoryName: 'Hello World',
              },
            },
          ],
          asset: { url: 'Hello World' },
          restaurant: {
            id: 'e3c2470d-5f38-4aff-a742-2c62933169f0',
            name: 'Hello World',
            isOutpost: true,
          },
          deliveryOrderDetail: {
            id: 'ff6a9347-d88d-48ee-a30f-22b944d253ab',
            address: {
              id: '94c40130-7664-4c55-b9f5-16095e6ededc',
              name: 'Hello World',
            },
          },
        },
      ],
    },
  },
};

export const orderHistoryWithIsCanceledFieldQueryMock: ExecutionResult<OrderHistoryWithIsCanceledFieldQuery> =
  {
    data: {
      orders: {
        __typename: 'OrdersResponseSuccess',
        pagination: { total: 16 },
        orders: [
          {
            id: '1aaeec36-e405-445d-8c25-4bfa75913529',
            orderType: 'DELIVERY',
            wantedTime: 'Hello World',
            description: 'Hello World',
            total: -78,
            canCancel: true,
            lineItems: [
              {
                id: '5511cbad-1e17-4121-8cef-4b3e48fb0e31',
                customName: 'Hello World',
                isCustom: true,
                product: {
                  id: 'b26ed5bc-4c8c-41e2-99d2-034853385b5d',
                  name: 'Hello World',
                  isCustom: false,
                  categoryName: 'Hello World',
                },
              },
              {
                id: 'd6c3a3f0-28c5-4aed-a362-2b166685446f',
                customName: 'Hello World',
                isCustom: false,
                product: {
                  id: '2ce31741-c5d1-4bce-9113-01d3f8c0a7ac',
                  name: 'Hello World',
                  isCustom: false,
                  categoryName: 'Hello World',
                },
              },
            ],
            asset: { url: 'Hello World' },
            restaurant: {
              id: '4fdbbcdd-3501-4c15-8b21-35e52a78d34f',
              name: 'Hello World',
              isOutpost: true,
            },
            deliveryOrderDetail: {
              id: 'c519c93f-c539-438f-9a43-a0d980380a5f',
              address: {
                id: '9c5deb88-3501-4cde-96c3-7eabd31d4e1c',
                name: 'Hello World',
              },
            },
            isCanceled: false,
          },
          {
            id: '8c83a196-f205-4d87-bd33-23c3c4c78fe9',
            orderType: 'DELIVERY',
            wantedTime: 'Hello World',
            description: 'Hello World',
            total: -15,
            canCancel: true,
            lineItems: [
              {
                id: 'fc6c7c7e-f3fd-467f-a9d9-40ac3a65d867',
                customName: 'Hello World',
                isCustom: true,
                product: {
                  id: '828cb8f2-533a-4adc-a114-c46d72b99b38',
                  name: 'Hello World',
                  isCustom: true,
                  categoryName: 'Hello World',
                },
              },
            ],
            asset: { url: 'Hello World' },
            restaurant: {
              id: '4361b55e-6971-48e5-9992-088fef6ff298',
              name: 'Hello World',
              isOutpost: false,
            },
            deliveryOrderDetail: {
              id: '29a3ffd3-24a9-4355-a65b-630e90736584',
              address: {
                id: 'a2702158-979d-4ae4-a7d6-e8a1a754372c',
                name: 'Hello World',
              },
            },
            isCanceled: false,
          },
        ],
      },
    },
  };
export const OrderFieldsFragmentDoc = gql`
  fragment OrderFields on Order {
    id
    orderType
    wantedTime
    description
    total
    canCancel
    lineItems {
      id
      customName
      isCustom
      product {
        id
        name
        isCustom
        categoryName
      }
    }
    asset {
      url
    }
    restaurant {
      id
      name
      isOutpost
    }
    deliveryOrderDetail {
      id
      address {
        id
        name
      }
    }
  }
`;
export const OrderHistoryDocument = gql`
  query orderHistory($input: OrdersInput!) {
    orders(input: $input) {
      __typename
      ... on OrdersResponseSuccess {
        pagination {
          total
        }
        orders {
          ...OrderFields
        }
      }
      ...ValidationErrorFields
    }
  }
  ${OrderFieldsFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
`;

export function useOrderHistoryQuery(
  options: Omit<Urql.UseQueryArgs<OrderHistoryQueryVariables>, 'query'>,
) {
  return Urql.useQuery<OrderHistoryQuery, OrderHistoryQueryVariables>({
    query: OrderHistoryDocument,
    ...options,
  });
}
export const OrderHistoryWithIsCanceledFieldDocument = gql`
  query orderHistoryWithIsCanceledField($input: OrdersInput!) {
    orders(input: $input) {
      __typename
      ... on OrdersResponseSuccess {
        pagination {
          total
        }
        orders {
          ...OrderFields
          isCanceled
        }
      }
      ...ValidationErrorFields
    }
  }
  ${OrderFieldsFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
`;

export function useOrderHistoryWithIsCanceledFieldQuery(
  options: Omit<
    Urql.UseQueryArgs<OrderHistoryWithIsCanceledFieldQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    OrderHistoryWithIsCanceledFieldQuery,
    OrderHistoryWithIsCanceledFieldQueryVariables
  >({ query: OrderHistoryWithIsCanceledFieldDocument, ...options });
}
